import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  INotificationsResponse,
  INotificationsSummary,
} from '../../_interfaces/IReminder';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private baseUrl = `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1`;

  constructor(private http: HttpClient) {}

  getNotifications(
    customersId: number,
    page = 0,
    limit = 10,
    unreadOnly = false,
  ): Observable<INotificationsResponse> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));
    if (unreadOnly) params = params.set('unread', 'true');

    return this.http.get<INotificationsResponse>(
      `${this.baseUrl}/customers/${customersId}/notifications`,
      { params },
    );
  }

  getSummary(customersId: number): Observable<INotificationsSummary> {
    return this.http.get<INotificationsSummary>(
      `${this.baseUrl}/customers/${customersId}/notifications/summary`,
    );
  }

  markAllAsRead(customersId: number): Observable<{ success: boolean; updated_count: number }> {
    return this.http.patch<{ success: boolean; updated_count: number }>(
      `${this.baseUrl}/customers/${customersId}/notifications/mark-all-read`,
      {},
    );
  }
}
